import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { LuggagePerFoldingSeat, LuggagePerFoldingSeatValue } from 'src/app/models/LuggagePerFoldingSeat.model';
import { RackSecurity } from 'src/app/models/RackSecurity.model';
import { SecurityAdjustmentFactor, SecurityAdjustmentFactorValue } from 'src/app/models/SecurityAdjustmentFactor.model';
import { TransportMode } from 'src/app/models/transportMode.model';
import { LuggagePerFoldingSeatData } from './luggagePerFoldingSeatData';
import { SecurityAdjustmentFactorData } from './securityAdjustmentFactorData';

@Component({
  selector: 'app-special-factors',
  templateUrl: './special-factors.component.html',
  styleUrls: ['./special-factors.component.scss']
})
export class SpecialFactorsComponent implements OnInit {

  @Input('form') parentForm: FormGroup;
  @Input('oppositeDoorReductionFactorValue') oppositeDoorReductionFactorValue: number;
  @Input('beforeSeatReductionFactorValue') beforeSeatReductionFactorValue: number;
  @Input('notUsableSeatFactorValue') notUsableSeatFactorValue: number;
  @Input('distanceBetweenPeople') distanceBetweenPeople: number;
  @Input('distanceBetweenPeopleAisle') distanceBetweenPeopleAisle: number;
  @Input('distanceBetweenPeopleStairs') distanceBetweenPeopleStairs: number;
  @Input('rackCapacityRoundingThreshold') rackCapacityRoundingThreshold: number;
  @Input('minimumUnderSeatHeight') minimumUnderSeatHeight: number;
  @Input('overheadHeightReductionFactor') overheadHeightReductionFactor: number;
  @Input('overheadLengthReductionFactor') overheadLengthReductionFactor: number;
  @Input('overheadLengthReductionThreshold') overheadLengthReductionThreshold: number;
  @Input('handleReductionFactor') handleReductionFactor: number;
  @Input('luggagePerFoldingSeat') luggagePerFoldingSeat: LuggagePerFoldingSeat;
  @Input('overencumberFactor') overencumberFactor: number;

  @Input('isEditable') isEditable: boolean;
  @Input('isImported') isImported: boolean;
  @Input('securityAdjustmentFactors') securityAdjustmentFactors: SecurityAdjustmentFactor = null;
  @Input('rackSecurities') rackSecurities: RackSecurity[] = [];
  @Input('transportModes') transportModes: TransportMode[] = [];
  form: FormGroup = null;
  gridDataSecurityAdjustmentFactor: GridData = null;
  gridDataLuggagePerFoldingSeat: GridData = null;
  lascCtrlSecurityAdjustmentFactor;
  lascCtrlLuggagePerFoldingSeat;
  securityAdjustmentFactorData: SecurityAdjustmentFactorData[] = [];
  luggagePerFoldingSeatData: LuggagePerFoldingSeatData[] = [];

  notUsableSeatFactorTooltip = "Zahl durch welche die übriggebliebene Gepäckstückanzahl dividiert wird.";
  oppositeDoorReductionFactorValueTooltip = "Anpassungsungsfaktor Gepäckrack-Lage. Faktor mit welchem alle Längen des Gepäckfachs in einem Rack multipliziert werden, wenn das Rack in der Reihenfolge Rack, Tür, Passagierberich vorkommt.";
  beforeSeatReductionFactorTooltip = "Anpassungsungsfaktor Gepäckrack-Lage. Faktor mit welchem alle Längen des Gepäckfachs in einem Rack multipliziert werden, wenn das Rack in der Reihenfolge Tür, Rack, Passagierberich vorkommt.";
  distanceBetweenPeopleTooltip = "Abstand zwischen zwei Personen für Polinomfaktor:flin. Abstand Eingangstür zur ersten Rückenlehne wird dadurch dividiert.";
  distanceBetweenPeopleAisleTooltip = "Personen die im Gang stehen können bevor sie sich stauen. Länge des Gangs wird durch diesen Faktor dividiert.";
  distanceBetweenPeopleStairsTooltip = "Personen die auf den Stiegen stehen können bevor sie sich stauen. Länge der Stiegen wird durch diesen Faktor dividiert.";
  rackCapacityRoundingThresholdTooltip = "Wert bis zu welchem die Kapazität der Racks abgerundet wird.";
  minimumUnderSeatHeightTooltip = "Minimale Höhe unter einem Sitz in mm, damit der Platz überhaupt als Gepäckablagefläche herangezogen wird. ";
  overheadHeightReductionFactorTooltip = "mm um welche die Höhe der Überkopfablage verringert wird.";
  overheadLengthReductionFactorTooltip = "Faktor mit dem die Länge der Überkopfablage multipliziert wird, wenn sie Länger als OverheadLengthReductionThreshold ist.";
  overheadLengthReductionThresholdTooltip = "Länge in mm ab welcher die Länge der Überkopfablage verringert wird.";
  handleReductionFactorTooltip = "In Gepäckabstellflächen untergebrachtes Gepäck wird um diesen faktor verringert. (Kofferanzahl*HandleReductionFactor).";
  securityAdjustmentFactorTooltip = "3 Faktoren um wie viel mehr Platz in einem Rack-Fach ist. Wird mit der eigentlichen Fachgöße multipliziert.";
  luggagePerFoldingSeatTooltip = "Wie viele große Gepäckstücke pro Klappsitz untergebracht werden können. (Klappsitz*LuggagePerFoldingSeat).";
  overencumberFactorTooltip = "Faktor, der in der Formel zur Berechnung der Passagiere verwendet wird, die zu einer Waggonüberfüllung führen";

  constructor() {
  }

  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('notUsableSeatFactor', new FormControl({ value: this.notUsableSeatFactorValue, disabled: this.isEditable }));
    this.form.addControl('oppositeDoorReductionFactorValue', new FormControl({ value: this.oppositeDoorReductionFactorValue, disabled: this.isEditable }));
    this.form.addControl('beforeSeatReductionFactorValue', new FormControl({ value: this.beforeSeatReductionFactorValue, disabled: this.isEditable }));
    this.form.addControl('securityAdjustmentFactor', new FormControl({ value: this.securityAdjustmentFactors, disabled: this.isEditable }));
    this.form.addControl('distanceBetweenPeople', new FormControl({ value: this.distanceBetweenPeople, disabled: this.isEditable }));
    this.form.addControl('distanceBetweenPeopleAisle', new FormControl({ value: this.distanceBetweenPeopleAisle, disabled: this.isEditable }));
    this.form.addControl('distanceBetweenPeopleStairs', new FormControl({ value: this.distanceBetweenPeopleStairs, disabled: this.isEditable }));
    this.form.addControl('rackCapacityRoundingThreshold', new FormControl({ value: this.rackCapacityRoundingThreshold, disabled: this.isEditable }));
    this.form.addControl('minimumUnderSeatHeight', new FormControl({ value: this.minimumUnderSeatHeight, disabled: this.isEditable }));
    this.form.addControl('overheadHeightReductionFactor', new FormControl({ value: this.overheadHeightReductionFactor, disabled: this.isEditable }));
    this.form.addControl('overheadLengthReductionFactor', new FormControl({ value: this.overheadLengthReductionFactor, disabled: this.isEditable }));
    this.form.addControl('overheadLengthReductionThreshold', new FormControl({ value: this.overheadLengthReductionThreshold, disabled: this.isEditable }));
    this.form.addControl('handleReductionFactor', new FormControl({ value: this.handleReductionFactor, disabled: this.isEditable }));
    this.form.addControl('luggagePerFoldingSeat', new FormControl({ value: this.luggagePerFoldingSeat, disabled: this.isEditable }));
    this.form.addControl('overencumberFactor', new FormControl({ value: this.overencumberFactor, disabled: this.isEditable }));
    this.lascCtrlSecurityAdjustmentFactor = this.form.get('securityAdjustmentFactor');
    this.lascCtrlLuggagePerFoldingSeat = this.form.get('luggagePerFoldingSeat');
    this.securityAdjustmentFactors = this.lascCtrlSecurityAdjustmentFactor.value as SecurityAdjustmentFactor;
    this.luggagePerFoldingSeat = this.lascCtrlLuggagePerFoldingSeat.value as LuggagePerFoldingSeat;
    this.gridDataSecurityAdjustmentFactor = this.ConvertDataSecurityAdjustmentFactor();
    this.gridDataLuggagePerFoldingSeat = this.ConvertDataLuggagePerFoldingSeat();
  }

  ConvertDataLuggagePerFoldingSeat(): GridData {
    for (let i = 0; i < this.luggagePerFoldingSeat.values.length; i++) {
      const element = this.luggagePerFoldingSeat.values[i];
      let tmpLuggagePerFoldingSeat: LuggagePerFoldingSeatData = new LuggagePerFoldingSeatData();
      tmpLuggagePerFoldingSeat.colId = element.transportModeId;
      tmpLuggagePerFoldingSeat.rowId = 1;
      tmpLuggagePerFoldingSeat.value = element.value;
      this.luggagePerFoldingSeatData.push(tmpLuggagePerFoldingSeat);
    }

    let rowHeaders: IdValue[] = [];
    rowHeaders.push(new IdValue(1, 'Value'));

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.transportModes.length; i++) {
      const headerEntry = this.transportModes[i];
      colHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }

    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.luggagePerFoldingSeatData;
    grid.colProp = 'colId';
    grid.rowProp = 'rowId';
    grid.switchColWithRow = false;

    return grid;
  }

  ConvertDataSecurityAdjustmentFactor(): GridData {
    for (let i = 0; i < this.securityAdjustmentFactors.values.length; i++) {
      const element = this.securityAdjustmentFactors.values[i];
      let tmpSecurityAdjustmentFactorData: SecurityAdjustmentFactorData = new SecurityAdjustmentFactorData();
      tmpSecurityAdjustmentFactorData.colId = element.securitytId + 1;
      tmpSecurityAdjustmentFactorData.rowId = 1;
      tmpSecurityAdjustmentFactorData.value = element.value;
      this.securityAdjustmentFactorData.push(tmpSecurityAdjustmentFactorData);
    }

    let rowHeaders: IdValue[] = [];
    rowHeaders.push(new IdValue(1, 'Value'));

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.rackSecurities.length; i++) {
      const headerEntry = this.rackSecurities[i];
      colHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }

    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.securityAdjustmentFactorData;
    grid.colProp = 'colId';
    grid.rowProp = 'rowId';
    grid.switchColWithRow = false;
    
    return grid;
  }

  ConvertDataSecurityAdjustmentFactorBack(temp: SecurityAdjustmentFactorData[]) {
    let factors: SecurityAdjustmentFactor = new SecurityAdjustmentFactor();
    let vals: SecurityAdjustmentFactorValue[] = [];
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      let val: SecurityAdjustmentFactorValue = new SecurityAdjustmentFactorValue();
      val.securitytId = element.colId - 1;
      val.value = element.value;
      vals.push(val);
    }
    factors.values = vals;
    factors.id = this.securityAdjustmentFactors.id;
    this.securityAdjustmentFactors = factors;
  }

  ConvertDataLuggagePerFoldingSeatBack(temp: LuggagePerFoldingSeatData[]) {
    let factors: LuggagePerFoldingSeat = new LuggagePerFoldingSeat();
    let vals: LuggagePerFoldingSeatValue[] = [];
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      let val: LuggagePerFoldingSeatValue = new LuggagePerFoldingSeatValue();
      val.transportModeId = element.colId;
      val.value = element.value;
      vals.push(val);
    }
    factors.values = vals;
    factors.id = this.luggagePerFoldingSeat.id;
    this.luggagePerFoldingSeat = factors;
  }

  save() {
    this.ConvertDataSecurityAdjustmentFactorBack(this.securityAdjustmentFactorData);
    this.ConvertDataLuggagePerFoldingSeatBack(this.luggagePerFoldingSeatData);
    if (this.lascCtrlSecurityAdjustmentFactor !== null) {
      this.lascCtrlSecurityAdjustmentFactor.patchValue(this.securityAdjustmentFactors);
    }
    if (this.lascCtrlLuggagePerFoldingSeat !== null) {
      this.lascCtrlLuggagePerFoldingSeat.patchValue(this.luggagePerFoldingSeat);
    }
  }
}
